/* ============================================================
   „Gestaltung als PDF speichern“ (13.10.2026)

   Erzeugt im Browser eine A4-PDF mit dem, was der Kunde gerade
   konfiguriert hat: Produkt, Variante, Menge, Preis, Vorschaubilder
   je Position und alle Angaben (Text, Schrift, Größe, Garnfarbe …).
   Nur für den Kunden – geht NICHT in Warenkorb oder Bestellung.

   Datenquellen (nichts wird doppelt berechnet):
   - Vorschaubilder: die vorhandenen Vorschauen der sichtbaren Karte
     (.sk-prev, .wl__vorschau / .wl__blockprev, .dtf__preview)
   - Angaben: die Line-Item-Properties im Produktformular (dieselben
     Felder, die beim Kauf mitgehen), ohne versteckte „_“-Felder
   - Preis: Kopfzeile der Mengenstaffeln, sonst Variantenpreis × Menge

   jsPDF + html2canvas werden erst beim Klick von cdnjs geladen.
   ============================================================ */
var MARKE = ((document.querySelector('meta[property="og:site_name"]') || {}).content || document.title.split(' – ').pop() || 'Shop').toUpperCase();
(function () {
  if (window.__zxPdfGestaltung) return;
  window.__zxPdfGestaltung = true;

  var LIBS = [
    'https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js',
    'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js'
  ];
  var LABEL = { vorne: 'Vorne', hinten: 'Hinten', links: 'Links', rechts: 'Rechts' };
  var BRAUN = [59, 42, 32];

  function skript(src) {
    return new Promise(function (ok, fehler) {
      if (document.querySelector('script[data-zxpdf="' + src + '"]')) return ok();
      var s = document.createElement('script');
      s.src = src; s.async = true; s.dataset.zxpdf = src;
      s.onload = ok; s.onerror = function () { fehler(new Error('Laden fehlgeschlagen: ' + src)); };
      document.head.appendChild(s);
    });
  }

  function sichtbar(el) { return !!(el && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden'); }

  function aktiveKarte() {
    return ['stickerei-karte', 'wunschlogo-karte', 'dtf-optionen']
      .map(function (id) { return document.getElementById(id); })
      .filter(sichtbar)[0] || null;
  }

  /* Vorschauelemente der sichtbaren Karte mit Beschriftung */
  function vorschauen(karte) {
    var liste = [];
    if (!karte) return liste;
    if (karte.id === 'stickerei-karte') {
      karte.querySelectorAll('.sk-block').forEach(function (b) {
        var el = b.querySelector('.sk-prev');
        if (sichtbar(el)) liste.push({ titel: LABEL[b.dataset.position] || b.dataset.position, el: el });
      });
    } else if (karte.id === 'wunschlogo-karte') {
      var logo = karte.querySelector('#wl-vorschau');
      if (sichtbar(logo)) liste.push({ titel: 'Vorne · Logo', el: logo });
      karte.querySelectorAll('.wl__block').forEach(function (b) {
        var el = b.querySelector('.wl__blockprev');
        var m = (b.className.match(/wl__block--(\w+)/) || [])[1];
        if (sichtbar(el)) liste.push({ titel: (LABEL[m] || m || 'Position') + ' · Text', el: el });
      });
    } else {
      karte.querySelectorAll('.dtf__preview').forEach(function (el) {
        if (sichtbar(el)) liste.push({ titel: (LABEL[el.dataset.position] || el.dataset.position) + ' · DTF-Druck', el: el });
      });
    }
    return liste;
  }

  /* Angaben aus dem Formular (= das, was auch in den Warenkorb ginge) */
  function angaben(form) {
    var zeilen = [], gesehen = {};
    if (!form) return zeilen;
    form.querySelectorAll('[name^="properties["]').forEach(function (el) {
      if (el.disabled || el.type === 'file') return;
      if ((el.type === 'radio' || el.type === 'checkbox') && !el.checked) return;
      var name = el.name.slice(11, -1);
      if (!name || name.charAt(0) === '_') return;
      var host = el.closest('#stickerei-karte, #wunschlogo-karte, #dtf-optionen');
      if (host && !sichtbar(host)) return;
      var wert = el.tagName === 'SELECT'
        ? ((el.options[el.selectedIndex] || {}).text || '')
        : el.value;
      wert = String(wert || '').trim();
      if (!wert || /^bitte w(ä|ae)hlen/i.test(wert)) return;
      if (gesehen[name] !== undefined) { zeilen[gesehen[name]][1] = wert; return; }
      gesehen[name] = zeilen.length;
      zeilen.push([name, wert]);
    });
    return zeilen;
  }

  function euro(cent) {
    return (cent / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' €';
  }

  async function produktDaten(form) {
    var info = { titel: '', variante: '', handle: 'produkt', preisZeile: '' };
    // .product__title enthaelt h1 + versteckten Link-Titel -> h1 bevorzugen
    var t = document.querySelector('.product__title h1') || document.querySelector('h1');
    info.titel = (t ? t.textContent : document.title).replace(/\s+/g, ' ').trim();
    // Dawn setzt das Mengenfeld ausserhalb des <form> (form="…"-Attribut)
    var mengeEl = document.querySelector('.product-form__quantity .quantity__input') ||
      (form && form.querySelector('[name="quantity"]'));
    var menge = parseInt(mengeEl && mengeEl.value, 10) || 1;
    info.menge = menge;
    try {
      var p = await (await fetch(location.pathname.replace(/\/$/, '') + '.js', { credentials: 'same-origin' })).json();
      info.handle = p.handle || info.handle;
      var id = (form && form.querySelector('[name="id"]') || {}).value;
      var v = (p.variants || []).filter(function (x) { return String(x.id) === String(id); })[0] || p.variants[0];
      if (v) { info.variante = v.public_title || v.title || ''; info.preisFallback = euro(v.price) + ' je Stück · gesamt ' + euro(v.price * menge); }
    } catch (e) { /* ohne Variante weiter */ }
    var kopf = document.querySelector('.ms__kopf');
    var proStueck = document.querySelector('.ms__preis-je-stueck');
    var gesamt = document.querySelector('.ms__gesamt');
    if (kopf && proStueck && proStueck.textContent.trim()) {
      info.preisZeile = proStueck.textContent.trim().replace(/\s+/g, ' ') + (gesamt ? ' · ' + gesamt.textContent.trim().replace(/\s+/g, ' ') : '');
    } else {
      info.preisZeile = info.preisFallback || '';
    }
    return info;
  }

  async function aufnehmen(el) {
    var canvas = await window.html2canvas(el, {
      useCORS: true, backgroundColor: '#ffffff', scale: Math.min(3, Math.max(2, window.devicePixelRatio || 1)), logging: false,
      ignoreElements: function (n) { return n.classList && (n.classList.contains('sk-resize') || n.classList.contains('wl__resize') || /griff|handle/i.test(n.className || '')); }
    });
    return { url: canvas.toDataURL('image/jpeg', 0.92), w: canvas.width, h: canvas.height };
  }

  async function erstellen(knopf) {
    var form = knopf.closest('form') || document.querySelector('form[action*="/cart/add"]');
    var karte = aktiveKarte();
    var textAlt = knopf.querySelector('[data-zx-pdf-text]').textContent;
    knopf.disabled = true;
    knopf.querySelector('[data-zx-pdf-text]').textContent = 'PDF wird erstellt …';
    try {
      await Promise.all(LIBS.map(skript));
      if (document.fonts && document.fonts.ready) await document.fonts.ready;
      var info = await produktDaten(form);
      var bilder = [];
      for (var v of vorschauen(karte)) {
        try { bilder.push(Object.assign({ titel: v.titel }, await aufnehmen(v.el))); } catch (e) { /* Bild auslassen */ }
      }
      var daten = angaben(form);

      var doc = new window.jspdf.jsPDF({ unit: 'mm', format: 'a4' });
      var B = 210, H = 297, R = 16, y = 18;
      var neueSeiteFalls = function (bedarf) { if (y + bedarf > H - 18) { doc.addPage(); y = 18; } };

      // Kopf
      doc.setTextColor.apply(doc, BRAUN);
      doc.setFont('helvetica', 'bold'); doc.setFontSize(20); doc.text(MARKE, R, y);
      doc.setFont('helvetica', 'normal'); doc.setFontSize(10);
      doc.text('Deine Gestaltung · ' + new Date().toLocaleDateString('de-DE'), B - R, y, { align: 'right' });
      y += 4; doc.setDrawColor(220, 214, 206); doc.line(R, y, B - R, y); y += 10;

      doc.setTextColor(20, 20, 20);
      doc.setFont('helvetica', 'bold'); doc.setFontSize(15);
      doc.splitTextToSize(info.titel, B - 2 * R).forEach(function (z) { doc.text(z, R, y); y += 6.5; });
      doc.setFont('helvetica', 'normal'); doc.setFontSize(10.5); doc.setTextColor(70, 64, 58);
      if (info.variante) { doc.text('Variante: ' + info.variante, R, y); y += 5.5; }
      doc.text('Menge: ' + info.menge + ' Stück', R, y); y += 5.5;
      if (info.preisZeile) { doc.text('Preis: ' + info.preisZeile, R, y); y += 5.5; }
      y += 4;

      // Vorschaubilder, zwei pro Reihe
      if (bilder.length) {
        var spalte = (B - 2 * R - 8) / 2;
        for (var i = 0; i < bilder.length; i += 2) {
          var reihe = bilder.slice(i, i + 2);
          var hoehen = reihe.map(function (b) { return Math.min(spalte * b.h / b.w, 95); });
          var hMax = Math.max.apply(null, hoehen);
          neueSeiteFalls(hMax + 10);
          reihe.forEach(function (b, k) {
            var x = R + k * (spalte + 8), h = hoehen[k], w = h * b.w / b.h;
            doc.setFont('helvetica', 'bold'); doc.setFontSize(9.5); doc.setTextColor.apply(doc, BRAUN);
            doc.text(b.titel, x, y);
            doc.setDrawColor(228, 222, 214); doc.roundedRect(x, y + 2, spalte, h + 2, 2, 2);
            doc.addImage(b.url, 'JPEG', x + (spalte - w) / 2, y + 3, w, h);
          });
          y += hMax + 12;
        }
      }

      // Angaben
      if (daten.length) {
        neueSeiteFalls(16);
        doc.setFont('helvetica', 'bold'); doc.setFontSize(11.5); doc.setTextColor.apply(doc, BRAUN);
        doc.text('Deine Angaben', R, y); y += 7;
        daten.forEach(function (z) {
          doc.setFont('helvetica', 'normal'); doc.setFontSize(10);
          var wert = doc.splitTextToSize(z[1], B - 2 * R - 58);
          var hoehe = Math.max(1, wert.length) * 4.8 + 2;
          neueSeiteFalls(hoehe);
          doc.setTextColor(110, 102, 94); doc.text(doc.splitTextToSize(z[0], 54), R, y);
          doc.setTextColor(20, 20, 20); doc.text(wert, R + 58, y);
          y += hoehe;
          doc.setDrawColor(238, 234, 228); doc.line(R, y - 2.4, B - R, y - 2.4);
        });
      }

      // Fuß
      neueSeiteFalls(16);
      y = Math.max(y + 4, H - 26);
      doc.setFont('helvetica', 'normal'); doc.setFontSize(8.5); doc.setTextColor(120, 112, 104);
      doc.text(doc.splitTextToSize('Die Vorschau dient nur zur Orientierung. Position und Größe können leicht abweichen – die Stickerei wird von unserem Produktionsteam zentriert und optimiert. Diese PDF ist keine Bestellung.', B - 2 * R), R, y);
      doc.text(location.host + location.pathname, R, H - 10);

      var datum = new Date().toISOString().slice(0, 10);
      doc.save(MARKE.toLowerCase().replace(/[^a-z0-9]+/g, '-') + '-gestaltung-' + info.handle + '-' + datum + '.pdf');
    } catch (e) {
      console.error('[PDF-Gestaltung]', e);
      alert('Die PDF konnte gerade nicht erstellt werden. Bitte versuche es noch einmal.');
    } finally {
      knopf.disabled = false;
      knopf.querySelector('[data-zx-pdf-text]').textContent = textAlt;
    }
  }

  document.addEventListener('click', function (e) {
    var knopf = e.target.closest('[data-zx-pdf]');
    if (!knopf) return;
    e.preventDefault();
    erstellen(knopf);
  });
})();
